import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import SignInModal from '../account/SignInModal';
import SignUpModal from '../account/SignUpModal';
import PasswordRecoveryModal from '../account/PasswordRecoveryModal';
import headSVG from '../../resources/images/elemento_head.svg'
import headSVGMobile from '../../resources/images/mobile/header.svg'
import yellowCurve from '../../resources/images/amarelo2.svg'
import yellowCurveMobile from '../../resources/images/mobile/body2.svg'
import footerCurve from '../../resources/images/elemento_footer.svg'
import footerCurveMobile from '../../resources/images/mobile/footer.svg'
import purpleCurve from '../../resources/images/elemento_body_2.svg'
import purpleCurveMobile from '../../resources/images/mobile/body3.svg'
import numero1 from '../../resources/images/numero1.svg'
import numero2 from '../../resources/images/numero2.svg'
import numero3 from '../../resources/images/numero3.svg'
import {
    openSignInModal,
    openSignUpModal,
    openPasswordRecoveryModal,
    closeSignInModal,
    closeSignUpModal,
    closePasswordRecoveryModal,
    signIn,
    signUp,
    passwordRecovery
} from '../account/accountActions'
import constants from '../../config/constants';
import { userIsAuthenticated } from '../../common/services/auth';
import Loading from '../../components/Loading';

class HomePage extends Component {
    constructor() {
        super();
        this.state = {
            loading: true
        }
    }
    facebookResponse(response, isRegister) {
        const {
            status,
            first_name,
            last_name,
            email,
            id,
            picture,
            link,
            gender
        } = response;

        if (status === 'unknown')
            return;

        let data = {
            firstName: first_name,
            lastName: last_name,
            email,
            isFbLogin: true,
            fb_id: id,
            fb_mail_phone: email,
            fb_photo_url: picture.data.url,
            fb_json_data: JSON.stringify(response)
        };

        if (isRegister) {
            data.photoUrl = picture.data.url;
            data.fb_gender = gender;
            data.fb_profile_link = link;

            this.props.signUp(data)
                .then(() => this.props.history.push('/monte-seu-simulado'));
        } else {
            this.props.signIn(data)
                .then(() => this.props.history.push('/monte-seu-simulado'));
        }
    }

    googleResponse(response, isRegister) {
        const {
            email,
            familyName,
            givenName,
            googleId,
            imageUrl,
            status
        } = response.profileObj;

        if (status === 'unknown')
            return;

        let data = {
            firstName: givenName,
            lastName: familyName,
            email,
            isGoogleLogin: true,
            google_id: googleId,
        };

        if (isRegister) {
            data.photoUrl = imageUrl;

            this.props.signUp(data)
                .then(() => this.props.history.push('/monte-seu-simulado'));
        } else {
            this.props.signIn(data)
                .then(() => this.props.history.push('/monte-seu-simulado'));
        }
    }

    selectExam() {
        if (!this.props.user) {
            this.props.openSignInModal();
            return;
        }

        this.props.history.push('/monte-seu-simulado');
    }

    breakOnMobile() {
        if (window.innerWidth <= 768) {
            return (
                <Fragment>
                    <br />
                </Fragment>
            )
        }
    }

    render() {
        const lastYear = new Date().getFullYear() - 1;
        const currentYear = new Date().getFullYear();

        if (window.innerWidth > 728) {
            return (
                <Fragment>
                    <section className="first-section-wrapper">

                        <img src={headSVG} className="head-svg"></img>
                        <div className="first-section-div">
                            <h1 className="first-section-div--title lp-color--pink">Simulado Enem {currentYear}</h1>
                            <h2 className="first-section-div--text lp-color--gray">Treine com o Simulado Beduka. Ele usa o mesmo método de correção do ENEM e é 100% gratuito! Você pode personalizá-lo para focar nas disciplinas que mais precisa, ter acesso ao gabarito na hora e fazê-lo quantas vezes quiser. Aproveite!</h2>
                            <button className="start-button" onClick={() => this.selectExam()}>FAZER SIMULADO</button>
                        </div>
                    </section>
                    <section className="second-section">
                        <h2 className="first-section-div--text lp-color--gray">Onde fazer simulados para o ENEM?</h2>
                        <p className="second-section__paragraph">O Beduka é a melhor opção. Com nosso Simulado ENEM {currentYear} você treina <span className="second-section__span lp-color--lilac">quantas vezes quiser</span> antes da prova. Ele é <span className="second-section__span lp-color--lilac">totalmente composto de questões extraídas das provas passadas (2013 a {lastYear}).</span></p>
                        <p className="second-section__paragraph">Você pode praticar História, Geografia, Filosofia, Sociologia, Física, Química, Biologia, Português, Literatura, Inglês, Espanhol, Artes e Matemática. <span className="second-section__span lp-color--lilac">Depois de cada teste, você terá uma análise completa de seu desempenho.</span></p>
                        <p className="second-section__paragraph">Praticar com o nosso Simulado ENEM {currentYear} vai te ajudar a fazer as questões de forma mais tranquila e com mais agilidade quando chegar a prova real.</p>
                        <h2 className="first-section-div--text lp-color--gray">Simulado Enem com Correção TRI e gabarito na hora</h2>
                        <p className="second-section__paragraph">Sua nota no Simulado será calculada com o modelo de <span className="second-section__span lp-color--lilac">Teoria de Resposta ao Item (TRI)</span>. Exatamente a mesma métrica do Enem verdadeiro. Ou seja, a  <span className="second-section__span lp-color--lilac">sua nota no nosso Simulado ENEM reflete qual seria sua nota na prova oficial.</span></p>
                        <p className="second-section__paragraph lp-color--pink bold">Comece agora!</p>
                        <p className="second-section__paragraph"> <span className="second-section__span lp-color--lilac">Treinar com o nosso Simulado ENEM é como treinar com a prova oficial</span>, por isso praticar conosco aumenta muito as suas chances de ser aprovado. A melhor parte é que você refazer quantas vezes quiser até atingir um <span className="second-section__span lp-color--lilac">desempenho extraordinário</span></p>
                        <button className="start-button-purple mt-6" onClick={() => this.selectExam()}>FAZER SIMULADO ENEM</button>
                    </section>
                    <section className="questions-content">
                        <div className="questions-wrapper">
                            <div className="questions">
                                <img src={numero1} className="question-number"></img>
                                <div className="m-auto">
                                    <p className="question-title">Qual é o segredo do sucesso na prova?</p>
                                    <p className="no-margin question-text">O segredo do sucesso é sempre praticar bastante. Para isso, disponibilizamos este Simulado ENEM {currentYear}! As questões que se encontram nele são do mesmo molde das do Enem, por isso as chances de aprovação aumentam muito ao praticar com ele.</p>
                                </div>
                            </div>
                            <div className="questions">
                                <img src={numero2} className="question-number"></img>
                                <div className="m-auto">
                                    <p className="question-title">Há um limite para fazer os Simulados Enem do Beduka?</p>
                                    <p className="no-margin question-text">Não há limite! Faça nosso simulado quantas vezes quiser. Ele fica no ar 24 horas. É só voltar aqui e fazer quando quiser.</p>
                                </div>
                            </div>
                            <div className="questions">
                                <img src={numero3} className="question-number"></img>
                                <div className="m-auto">
                                    <p className="question-title">Quanto custa para fazer o Simulado Enem do Beduka?</p>
                                    <p className="no-margin question-text">Não custa nada! Nosso Simulado ENEM é 100% gratuito. Não é amostra grátis. Ele é completamente gratuito e continuará sendo!</p>
                                </div>
                            </div>
                            <button className="start-button-2 m-auto" onClick={() => this.selectExam()}>FAZER SIMULADO</button>
                        </div>
                    </section>
                    <section style={{ backgroundImage: `url(${footerCurve})` }} className="last-section">
                        <img className="last-section-svg"></img>
                        <p className="last-section-text">Compartilhe o Simulado ENEM do Beduka com seus amigos e os ajude a ir bem na prova também! Eles estão disponíveis em qualquer lugar; celular ou computador. É só acessar e fazer.
                        </p>
                        <p className="last-section-text-2">A vantagem dos simulados online é que eles podem ser feitos a qualquer momento e com todas as matérias que quiser.</p>
                        <p className="last-section-text-2 lp-color--purple">O Beduka te oferece o melhor simulado online e sem te cobrar nada. Comece já! </p>
                    </section>
                    <style dangerouslySetInnerHTML={{
                        __html: `
                        .bdk-footer { background-color: #631f8b }
                        .fa-stack-1x { color: #631f8b !important; }
                        .footer-new { color: #631f8b !important; }
                    `}} />
                    <SignInModal
                        isVisible={this.props.signInModalIsOpen}
                        onCloseModal={() => this.props.closeSignInModal()}
                        onSubmit={data => this.props.signIn(data).then(() => this.props.history.push('/monte-seu-simulado'))}
                        facebookSignIn={response => this.facebookResponse(response)}
                        openRecoveryPasswordModal={() => this.props.openPasswordRecoveryModal()}
                        openSignUpModal={() => this.props.openSignUpModal()}
                        message={this.props.accountMessage}
                        loading={this.props.loading}
                        googleSignIn={response => this.googleResponse(response)}
                    />
                    <SignUpModal
                        isVisible={this.props.signUpModalIsOpen}
                        onCloseModal={() => this.props.closeSignUpModal()}
                        onSubmit={data => this.props.signUp(data).then(() => this.props.history.push('/monte-seu-simulado'))}
                        facebookSignUp={response => this.facebookResponse(response, true)}
                        openSignInModal={() => this.props.openSignInModal()}
                        message={this.props.accountMessage}
                        loading={this.props.loading}
                        googleSignUp={response => this.googleResponse(response)}
                    />
                    <PasswordRecoveryModal
                        isVisible={this.props.passwordRecoveryModalIsOpen}
                        onCloseModal={() => this.props.closePasswordRecoveryModal()}
                        onSubmit={data => this.props.passwordRecovery(data)}
                        message={this.props.accountMessage}
                        loading={this.props.loading}
                    />
                </Fragment>
            )
        } else {
            return (
                <Fragment>
                    <section className="m-first-section-wrapper">
                        <img src={headSVGMobile} className="head-svg"></img>
                    </section>
                    <section className="m-second-section mb-8">
                        <h1 className="m-second-section__title">Simulado Enem {currentYear}</h1>
                        <button className="m-start-button-purple mb-2" onClick={() => this.selectExam()}>INICIAR SIMULADO ENEM</button>
                        <p className="m-second-section__paragraph">
                            Quer fazer simulados para o ENEM?
                            <br />
                            <span className="m-second-section__span lp-color--lilac">Treine com o Simulado Beduka. Ele usa o mesmo método de correção do ENEM e é 100% gratuito! Você pode personalizá-lo para focar nas disciplinas que mais precisa, ter acesso ao gabarito na hora e fazê-lo quantas vezes quiser. Aproveite!  </span>
                            O Beduka é a sua melhor opção.  Com nosso Simulado ENEM {currentYear} você treina <span className="m-second-section__span lp-color--lilac">quantas vezes quiser</span> antes da prova. Não há enrolação!
                            <span className="m-second-section__span lp-color--lilac"> As nossas questões são extraídas das provas anteriores (2013 a {lastYear}), </span>
                            assim você treina exatamente questões no padrão ENEM.
                            {/* <span className="m-second-section__paragraph lp-color--pink bold"> Comece agora!</span> */}
                        </p>
                    </section>
                    <div className="my-4"></div>
                    <div className="my-6"></div>
                    <section className="m-third-section">
                        <img src={yellowCurveMobile} className="m-yellow-curve-svg"></img>
                        <iframe src={"https://" + window.location.hostname + "/iframe/simulado"} allowtransparency="true" width="100%" className="m-iframe-bdk"></iframe>
                    </section>
                    <div className="my-2"></div>
                    <section className="questions-title">
                        <img src={purpleCurveMobile} className="purple-questions-svg"></img>
                        <p className="m-questions-title-p">DÚVIDAS</p>
                    </section>
                    <section className="m-questions-content lp-color--gray">
                        <div className="my-6">
                            <p className="lp-color--pink no-margin m-questions-text bold">
                                <span className="lp-color--purple m-questions-number">1 </span> O segredo do sucesso na prova?
                            </p>
                            <p className="m-questions-text">
                                Fazer o nosso simulado ENEM {currentYear}! <span className="lp-color--lilac"> As chances de ser aprovado aumentam muito, </span> já que você faz questões do mesmo padrão que você encontrará na sua prova oficial.
                            </p>
                        </div>
                        <div className="my-6">
                            <p className="lp-color--pink no-margin m-questions-text bold">
                                <span className="lp-color--purple m-questions-number">2 </span> Há um limite para fazer os simulados para Enem do Beduka?
                            </p>
                            <p className="m-questions-text">
                                Não, você pode fazer <span className="lp-color--lilac"> quantas vezes quiser </span> sem se preocupar. O simulado não sai do ar e você pode sempre voltar a treinar.
                            </p>
                        </div>
                        <div className="my-6">
                            <p className="lp-color--pink no-margin m-questions-text bold">
                                <span className="lp-color--purple m-questions-number">3 </span> Quanto custa para fazer os simulados Enem do Beduka?
                            </p>
                            <p className="m-questions-text">
                                <span className="lp-color--lilac">É totalmente gratuito. </span> Nenhum valor será cobrado. Não se trata de uma amostra para que você goste e depois tenha que pagar. O nosso conteúdo é completo e totalmente liberado. Isso não vai mudar!
                            </p>
                        </div>
                    </section>
                    <section style={{ backgroundImage: `url(${footerCurveMobile})` }} className="m-last-section">
                        <p className="m-last-section-text">Compartilhe com seus amigos essa ideia. Ajude-os a irem bem nas provas compartilhando o simulado Enem {currentYear} do Beduka com eles. Nossos simulados online com correção pela nota TRI podem ser feitos de qualquer lugar, no mobile ou no desktop.</p>
                        <p className="m-last-section-text-2">A vantagem em fazer simulados Enem online é que você pratica quando quiser, fazendo provas online de todas as matérias.</p>
                        <p className="m-last-section-text-2 lp-color--purple">O Beduka te oferece o melhor simulado gratuito e online para estudar para o Enem. Comece já!</p>
                    </section>
                    <style dangerouslySetInnerHTML={{
                        __html: `
                        .bdk-footer { background-color: #631f8b }
                        .fa-stack-1x { color: #631f8b !important; }
                        .footer-new { color: #631f8b !important; }
                    `}} />
                    <SignInModal
                        isVisible={this.props.signInModalIsOpen}
                        onCloseModal={() => this.props.closeSignInModal()}
                        onSubmit={data => this.props.signIn(data).then(() => this.props.history.push('/monte-seu-simulado'))}
                        facebookSignIn={response => this.facebookResponse(response)}
                        openRecoveryPasswordModal={() => this.props.openPasswordRecoveryModal()}
                        openSignUpModal={() => this.props.openSignUpModal()}
                        message={this.props.accountMessage}
                        loading={this.props.loading}
                        googleSignIn={response => this.googleResponse(response)}
                    />
                    <SignUpModal
                        isVisible={this.props.signUpModalIsOpen}
                        onCloseModal={() => this.props.closeSignUpModal()}
                        onSubmit={data => this.props.signUp(data).then(() => this.props.history.push('/monte-seu-simulado'))}
                        facebookSignUp={response => this.facebookResponse(response, true)}
                        openSignInModal={() => this.props.openSignInModal()}
                        message={this.props.accountMessage}
                        loading={this.props.loading}
                        googleSignUp={response => this.googleResponse(response)}
                    />
                    <PasswordRecoveryModal
                        isVisible={this.props.passwordRecoveryModalIsOpen}
                        onCloseModal={() => this.props.closePasswordRecoveryModal()}
                        onSubmit={data => this.props.passwordRecovery(data)}
                        message={this.props.accountMessage}
                        loading={this.props.loading}
                    />
                </Fragment>
            )
        }
    }

    componentDidMount() {
        if (userIsAuthenticated) {
            this.setState({loading: true})
            this.props.history.push('/monte-seu-simulado')
            this.setState({loading: false})

        }
    }
}

const mapStateToProps = state => {
    const {
        signInModalIsOpen,
        signUpModalIsOpen,
        passwordRecoveryModalIsOpen,
        message,
        user,
        loading
    } = state.account;

    return {
        signInModalIsOpen,
        signUpModalIsOpen,
        passwordRecoveryModalIsOpen,
        accountMessage: message,
        user,
        loading
    };
};

export default connect(mapStateToProps, {
    openSignInModal,
    openSignUpModal,
    openPasswordRecoveryModal,
    closeSignInModal,
    closeSignUpModal,
    closePasswordRecoveryModal,
    signIn,
    signUp,
    passwordRecovery
})(HomePage);
